// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SjNE","tabsBox":"styles_tabsBox__26roK","createButton":"styles_createButton__2ZmGX"};